"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoSuggest = void 0;
/*
 * © 2025 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importStar(require("react"));
const downshift_1 = require("downshift");
const Primitives_1 = require("../Primitives");
const MagnifyingGlass_1 = __importDefault(require("../Icons/MagnifyingGlass"));
const style_1 = require("./style");
const fp_1 = require("lodash/fp");
const AutoSuggest = ({ items, onSelect, placeholder, value, clearClicked }) => {
    const [inputItems, setInputItems] = (0, react_1.useState)(items);
    (0, react_1.useEffect)(() => {
        if (!(0, fp_1.isEqual)(items, inputItems)) {
            setInputItems(items);
        }
    }, [items, inputItems]);
    const valueIsDefined = value && value !== "";
    const filteredList = valueIsDefined
        ? items.filter((item) => item === null || item === void 0 ? void 0 : item.toLowerCase().includes(value === null || value === void 0 ? void 0 : value.toLowerCase()))
        : items;
    const { isOpen, getMenuProps, getInputProps, highlightedIndex, getItemProps, setHighlightedIndex, selectItem, } = (0, downshift_1.useCombobox)({
        items: filteredList,
        onInputValueChange: ({ inputValue }) => {
            setHighlightedIndex(0);
            onSelect(inputValue);
            value = inputValue;
        },
    });
    // When the clear all filters button is pressed the input gets
    // updated from outside of the control to undefined but internally
    // the selected item remains as what it was. This ensure the
    // internal selected value updates accordingly.
    (0, react_1.useEffect)(() => {
        if (value === undefined) {
            selectItem("");
        }
    }, [value, selectItem]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(style_1.Wrapper, null,
            react_1.default.createElement(MagnifyingGlass_1.default, null),
            react_1.default.createElement(Primitives_1.Input, { placeholder: placeholder ? placeholder : undefined, ...getInputProps(), value: value !== null && value !== void 0 ? value : "", clearButton: true, magnifyingGlass: true, autoFocus: true }),
            valueIsDefined && (react_1.default.createElement(Primitives_1.ClearButton, { onClick: () => {
                    clearClicked();
                } })),
            react_1.default.createElement(style_1.ListWrapper, { ...getMenuProps() }, isOpen &&
                filteredList.map((item, index) => (react_1.default.createElement(style_1.ComboBoxItemWrapper, { isSelected: highlightedIndex === index, key: `${item}${index}`, ...getItemProps({ item, index }) },
                    react_1.default.createElement(style_1.SelectedBar, { selected: highlightedIndex === index }),
                    item)))))));
};
exports.AutoSuggest = AutoSuggest;
//# sourceMappingURL=index.js.map